/* eslint-disable prettier/prettier */
// Import gsap
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText); 

export default class TextAnimation {    

    static animateTxt = (function() {
        //console.log('[START] animateTxt function 1.1');
        // split each element with the class "split" into words and characters
        document.querySelectorAll(".split").forEach((el) => {
            let split = SplitText.create(el, { type: "words, chars" });//words, chars, lines
            // now animate the characters in a staggered fashion
            gsap.from(split.words, {
                duration: .5,
                y: 100,       // animate from 100px below
                autoAlpha: 0, // fade in from opacity: 0 and visibility: hidden
                stagger: 0.05, // 0.05 seconds between each
                scrollTrigger: {
                    trigger: el,
                    scrub: 0.5,
                    start: "-10% center",
                    end: "60% center",
                    once : true, //play for one time
                    /*markers: {
                        startColor: "black",
                        endColor: "violet"
                    },*/
                }
            });
        });
        //console.log('[END] animateTxt function');
    });

    static init(){
        /*document.fonts.ready.then(() => {  let media = gsap.matchMedia();
        media.add("(min-width: 768px)", () => {
            TextAnimation.animateTxt();
        })  })*/
        TextAnimation.animateTxt();

        // le immagini caricate in modo asincrono spostano il layout dopo il calcolo
        // iniziale dei trigger: ricalcola le posizioni quando tutto è caricato
        //window.addEventListener('load', () => ScrollTrigger.refresh());
    }
}